// banner的字段结构类型
export type BannerModelType = {
  // 活动的名称，并用作埋点数据：臻有钱_${页面名称}_${name}
  name: string;
  // 图片地址
  image: string;
  // 点击时跳转的链接
  url: string;
};

// 动态获取首页或者我的页面的banner配置
export enum BannerSceneEnum {
  // 我的页面
  mine = "0",
  // 首页
  home = "1",
}
